import qs from 'qs';

import { client } from '../client';

export type ExportAuditTrailParams = {
  user_role?: string[]; // e.g. ['SuperAdmin', 'Admin']
  user_name?: string;
  user_id?: string;
  actor_name?: string;
  action_message?: string;
  search?: string;
  date_from?: string;
  date_to?: string;
  cursor?: string;
  case_id?: number;
  cases_only?: boolean;
  users_only?: boolean;
  include_case_creation?: boolean;
};

const normalizeExportParams = (params: ExportAuditTrailParams): ExportAuditTrailParams =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value != null && value !== '' && !(Array.isArray(value) && value.length === 0),
    ),
  ) as ExportAuditTrailParams;

export const exportAuditTrailCsv = async (
  params?: ExportAuditTrailParams | string,
  userRole?: string,
): Promise<Blob> => {
  const prefix = userRole === 'CareAdvisor' ? '/care_advisor' : userRole === 'Collector' ? '/collector' : '/admin';
  let queryString = '';

  if (params && typeof params === 'object') {
    queryString = `?${qs.stringify(normalizeExportParams(params), {
      skipNulls: true,
      arrayFormat: 'repeat',
      encodeValuesOnly: true,
    })}`;
  } else if (typeof params === 'string') {
    queryString = params.startsWith('?') ? params : `?${params}`;
  }

  const response = await client.get<Blob>(`${prefix}/audit_trails/export${queryString}`, {
    responseType: 'blob',
  });
  return response.data;
};
